/* tslint:disable */
/* eslint-disable */
/**
 * SciCrunch Antibody Registry API
 * Antibody Registry API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * The data type associated with the POST method of the antibody resource
 */
export interface AddAntibody {
    'catalogNum'?: string | null;
    'vendorName'?: string | null;
    'clonality'?: ClonalityEnum | null;
    'epitope'?: string | null;
    'comments'?: string | null;
    'url': string;
    'abName'?: string | null;
    'abTarget'?: string | null;
    'cloneId'?: string | null;
    'commercialType'?: CommercialTypeEnum | null;
    'definingCitation'?: string | null;
    'productConjugate'?: string | null;
    'productForm'?: string | null;
    'productIsotype'?: string | null;
    'sourceOrganism'?: string | null;
    'targetSpecies'?: Array<string> | null;
    'uniprotId'?: string | null;
    'applications'?: Array<string> | null;
    'kitContents'?: string | null;
    'abTargetEntrezId'?: string | null;
    'abTargetUniprotId'?: string | null;
    'numOfCitation'?: number | null;
}


/**
 * The data type associated with the antibody resource
 */
export interface Antibody {
    'catalogNum'?: string | null;
    'vendorName'?: string | null;
    'clonality'?: ClonalityEnum | null;
    'epitope'?: string | null;
    'comments'?: string | null;
    'url'?: string | null;
    'abName'?: string | null;
    'abTarget'?: string | null;
    'cloneId'?: string | null;
    'commercialType'?: CommercialTypeEnum | null;
    'definingCitation'?: string | null;
    'productConjugate'?: string | null;
    'productForm'?: string | null;
    'productIsotype'?: string | null;
    'sourceOrganism'?: string | null;
    'targetSpecies'?: Array<string> | null;
    'uniprotId'?: string | null;
    'applications'?: Array<string> | null;
    'kitContents'?: string | null;
    'abTargetEntrezId'?: string | null;
    'abTargetUniprotId'?: string | null;
    'numOfCitation'?: number | null;
    'accession'?: number | null;
    'status'?: AntibodyStatusEnum | null;
    'feedback'?: string | null;
    'abId'?: number | null;
    'catAlt'?: string | null;
    'curateTime'?: string | null;
    'curatorComment'?: string | null;
    'discDate'?: string | null;
    'insertTime'?: string | null;
    'targetModification'?: string | null;
    'targetSubregion'?: string | null;
    'vendorId'?: number | null;
    'lastEditTime'?: string | null;
    'ix'?: number | null;
    'showLink'?: boolean | null;
    'vendorUrl'?: Array<string> | null;
}



export const AntibodyStatusEnum = {
    Curated: 'CURATED',
    Rejected: 'REJECTED',
    Queue: 'QUEUE',
    UnderReview: 'UNDER_REVIEW'
} as const;

export type AntibodyStatusEnum = typeof AntibodyStatusEnum[keyof typeof AntibodyStatusEnum];



export const ClonalityEnum = {
    Unknown: 'unknown',
    Cocktail: 'cocktail',
    Control: 'control',
    IsotypeControl: 'isotype control',
    Monoclonal: 'monoclonal',
    MonoclonalSecondary: 'monoclonal secondary',
    Polyclonal: 'polyclonal',
    PolyclonalSecondary: 'polyclonal secondary',
    Oligoclonal: 'oligoclonal',
    Recombinant: 'recombinant',
    RecombinantMonoclonal: 'recombinant monoclonal',
    RecombinantMonoclonalSecondary: 'recombinant monoclonal secondary',
    RecombinantPolyclonal: 'recombinant polyclonal',
    RecombinantPolyclonalSecondary: 'recombinant polyclonal secondary'
} as const;

export type ClonalityEnum = typeof ClonalityEnum[keyof typeof ClonalityEnum];



export const CommercialTypeEnum = {
    Commercial: 'commercial',
    NonProfit: 'non-profit',
    Personal: 'personal',
    Other: 'other'
} as const;

export type CommercialTypeEnum = typeof CommercialTypeEnum[keyof typeof CommercialTypeEnum];


/**
 * Information about the data in the system
 */
export interface DataInfo {
    'total': number;
    'lastupdate': string;
}
/**
 * The search request body that allows filtering combinations over multiple columns
 */
export interface FilterRequest {
    'contains'?: Array<KeyValuePair> | null;
    'equals'?: Array<KeyValuePair> | null;
    'page'?: number | null;
    'size'?: number | null;
    'search'?: string | null;
    'endsWith'?: Array<KeyValuePair> | null;
    'sortOn'?: Array<KeyValueSortOrderPair> | null;
    'startsWith'?: Array<KeyValuePair> | null;
    'isEmpty'?: Array<string> | null;
    'isNotEmpty'?: Array<string> | null;
    'isAnyOf'?: Array<KeyValueArrayPair> | null;
    'operation'?: OperationEnum | null;
    'isUserScope'?: boolean | null;
}


/**
 * Request body for data ingestion
 */
export interface IngestRequest {
    'driveLinkOrId'?: string | null;
    'hot'?: boolean | null;
}
/**
 * Utility type to represent a key-value object where value is an array
 */
export interface KeyValueArrayPair {
    'key': string;
    'value': Array<string>;
}
/**
 * Utility type to represent a key-value object
 */
export interface KeyValuePair {
    'key': string;
    'value': string;
}
/**
 * Utility type to represent a key-value object with sort order
 */
export interface KeyValueSortOrderPair {
    'key': string;
    'sortorder': SortOrderEnum;
}



export const OperationEnum = {
    And: 'and',
    Or: 'or'
} as const;

export type OperationEnum = typeof OperationEnum[keyof typeof OperationEnum];


/**
 * Paginated response for antibodies
 */
export interface PaginatedAntibodies {
    'page': number;
    'totalElements': number;
    'items': Array<Antibody>;
}
/**
 * Response of the list of partners and related images
 */
export interface PartnerResponseObject {
    'name'?: string | null;
    'url'?: string | null;
    'image'?: string | null;
}

export const SortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SortOrderEnum = typeof SortOrderEnum[keyof typeof SortOrderEnum];


/**
 * The data type associated with the PUT method of the antibody resource
 */
export interface UpdateAntibody {
    'clonality'?: ClonalityEnum | null;
    'epitope'?: string | null;
    'comments'?: string | null;
    'url': string;
    'abName'?: string | null;
    'abTarget'?: string | null;
    'cloneId'?: string | null;
    'commercialType'?: CommercialTypeEnum | null;
    'definingCitation'?: string | null;
    'productConjugate'?: string | null;
    'productForm'?: string | null;
    'productIsotype'?: string | null;
    'sourceOrganism'?: string | null;
    'targetSpecies'?: Array<string> | null;
    'uniprotId'?: string | null;
    'applications'?: Array<string> | null;
    'kitContents'?: string | null;
    'abTargetEntrezId'?: string | null;
    'abTargetUniprotId'?: string | null;
    'numOfCitation'?: number | null;
}


/**
 * Vendor information
 */
export interface VendorSchema {
    'id'?: number | null;
    'name'?: string | null;
    'url'?: string | null;
    'description'?: string | null;
}

/**
 * AntibodyApi - axios parameter creator
 */
export const AntibodyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Antibody
         * @summary Create Antibody
         * @param {AddAntibody} addAntibody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyCreateAntibody: async (addAntibody: AddAntibody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addAntibody' is not null or undefined
            assertParamExists('apiRoutersAntibodyCreateAntibody', 'addAntibody', addAntibody)
            const localVarPath = `/api/antibodies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAntibody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export antibodies as CSV
         * @summary Export Antibodies Post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyExportAntibodiesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/antibodies/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Antibodies
         * @summary Get Antibodies
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {string | null} [updatedFrom] 
         * @param {string | null} [updatedTo] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibodies: async (page?: number | null, size?: number | null, updatedFrom?: string | null, updatedTo?: string | null, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/antibodies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (updatedFrom !== undefined) {
                localVarQueryParameter['updated_from'] = (updatedFrom as any instanceof Date) ?
                    (updatedFrom as any).toISOString() :
                    updatedFrom;
            }

            if (updatedTo !== undefined) {
                localVarQueryParameter['updated_to'] = (updatedTo as any instanceof Date) ?
                    (updatedTo as any).toISOString() :
                    updatedTo;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export all antibodies in csv format
         * @summary Get Antibodies Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibodiesExport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/antibodies/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export all fields of all antibodies to a CSV file - Only for admin users
         * @summary Get Antibodies Export Admin
         * @param {AntibodyStatusEnum | null} [status] 
         * @param {string | null} [lasteditTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibodiesExportAdmin: async (status?: AntibodyStatusEnum | null, lasteditTime?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/antibodies/export/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (lasteditTime !== undefined) {
                localVarQueryParameter['lastedit_time'] = (lasteditTime as any instanceof Date) ?
                    (lasteditTime as any).toISOString() :
                    lasteditTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Antibody
         * @summary Get Antibody
         * @param {number} antibodyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibody: async (antibodyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'antibodyId' is not null or undefined
            assertParamExists('apiRoutersAntibodyGetAntibody', 'antibodyId', antibodyId)
            const localVarPath = `/api/antibodies/{antibody_id}`
                .replace(`{${"antibody_id"}}`, encodeURIComponent(String(antibodyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get antibody by the accession number
         * @summary Get By Accession
         * @param {number} accessionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetByAccession: async (accessionNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessionNumber' is not null or undefined
            assertParamExists('apiRoutersAntibodyGetByAccession', 'accessionNumber', accessionNumber)
            const localVarPath = `/api/antibodies/user/{accession_number}`
                .replace(`{${"accession_number"}}`, encodeURIComponent(String(accessionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List user\'s Antibodies
         * @summary Get User Antibodies
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetUserAntibodies: async (page?: number | null, size?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/antibodies/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a submitted Antibody
         * @summary Update User Antibody
         * @param {number} accessionNumber 
         * @param {UpdateAntibody} updateAntibody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyUpdateUserAntibody: async (accessionNumber: number, updateAntibody: UpdateAntibody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessionNumber' is not null or undefined
            assertParamExists('apiRoutersAntibodyUpdateUserAntibody', 'accessionNumber', accessionNumber)
            // verify required parameter 'updateAntibody' is not null or undefined
            assertParamExists('apiRoutersAntibodyUpdateUserAntibody', 'updateAntibody', updateAntibody)
            const localVarPath = `/api/antibodies/user/{accession_number}`
                .replace(`{${"accession_number"}}`, encodeURIComponent(String(accessionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAntibody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AntibodyApi - functional programming interface
 */
export const AntibodyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AntibodyApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a Antibody
         * @summary Create Antibody
         * @param {AddAntibody} addAntibody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyCreateAntibody(addAntibody: AddAntibody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Antibody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyCreateAntibody(addAntibody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyCreateAntibody']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export antibodies as CSV
         * @summary Export Antibodies Post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyExportAntibodiesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyExportAntibodiesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyExportAntibodiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Antibodies
         * @summary Get Antibodies
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {string | null} [updatedFrom] 
         * @param {string | null} [updatedTo] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyGetAntibodies(page?: number | null, size?: number | null, updatedFrom?: string | null, updatedTo?: string | null, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAntibodies>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyGetAntibodies(page, size, updatedFrom, updatedTo, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyGetAntibodies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export all antibodies in csv format
         * @summary Get Antibodies Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyGetAntibodiesExport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyGetAntibodiesExport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyGetAntibodiesExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export all fields of all antibodies to a CSV file - Only for admin users
         * @summary Get Antibodies Export Admin
         * @param {AntibodyStatusEnum | null} [status] 
         * @param {string | null} [lasteditTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyGetAntibodiesExportAdmin(status?: AntibodyStatusEnum | null, lasteditTime?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyGetAntibodiesExportAdmin(status, lasteditTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyGetAntibodiesExportAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Antibody
         * @summary Get Antibody
         * @param {number} antibodyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyGetAntibody(antibodyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Antibody>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyGetAntibody(antibodyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyGetAntibody']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get antibody by the accession number
         * @summary Get By Accession
         * @param {number} accessionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyGetByAccession(accessionNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Antibody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyGetByAccession(accessionNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyGetByAccession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List user\'s Antibodies
         * @summary Get User Antibodies
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyGetUserAntibodies(page?: number | null, size?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAntibodies>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyGetUserAntibodies(page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyGetUserAntibodies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a submitted Antibody
         * @summary Update User Antibody
         * @param {number} accessionNumber 
         * @param {UpdateAntibody} updateAntibody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersAntibodyUpdateUserAntibody(accessionNumber: number, updateAntibody: UpdateAntibody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Antibody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersAntibodyUpdateUserAntibody(accessionNumber, updateAntibody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AntibodyApi.apiRoutersAntibodyUpdateUserAntibody']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AntibodyApi - factory interface
 */
export const AntibodyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AntibodyApiFp(configuration)
    return {
        /**
         * Create a Antibody
         * @summary Create Antibody
         * @param {AddAntibody} addAntibody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyCreateAntibody(addAntibody: AddAntibody, options?: RawAxiosRequestConfig): AxiosPromise<Antibody> {
            return localVarFp.apiRoutersAntibodyCreateAntibody(addAntibody, options).then((request) => request(axios, basePath));
        },
        /**
         * Export antibodies as CSV
         * @summary Export Antibodies Post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyExportAntibodiesPost(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiRoutersAntibodyExportAntibodiesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * List Antibodies
         * @summary Get Antibodies
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {string | null} [updatedFrom] 
         * @param {string | null} [updatedTo] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibodies(page?: number | null, size?: number | null, updatedFrom?: string | null, updatedTo?: string | null, status?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAntibodies> {
            return localVarFp.apiRoutersAntibodyGetAntibodies(page, size, updatedFrom, updatedTo, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Export all antibodies in csv format
         * @summary Get Antibodies Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibodiesExport(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRoutersAntibodyGetAntibodiesExport(options).then((request) => request(axios, basePath));
        },
        /**
         * Export all fields of all antibodies to a CSV file - Only for admin users
         * @summary Get Antibodies Export Admin
         * @param {AntibodyStatusEnum | null} [status] 
         * @param {string | null} [lasteditTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibodiesExportAdmin(status?: AntibodyStatusEnum | null, lasteditTime?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiRoutersAntibodyGetAntibodiesExportAdmin(status, lasteditTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Antibody
         * @summary Get Antibody
         * @param {number} antibodyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetAntibody(antibodyId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Antibody>> {
            return localVarFp.apiRoutersAntibodyGetAntibody(antibodyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get antibody by the accession number
         * @summary Get By Accession
         * @param {number} accessionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetByAccession(accessionNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<Antibody> {
            return localVarFp.apiRoutersAntibodyGetByAccession(accessionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * List user\'s Antibodies
         * @summary Get User Antibodies
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyGetUserAntibodies(page?: number | null, size?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAntibodies> {
            return localVarFp.apiRoutersAntibodyGetUserAntibodies(page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a submitted Antibody
         * @summary Update User Antibody
         * @param {number} accessionNumber 
         * @param {UpdateAntibody} updateAntibody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersAntibodyUpdateUserAntibody(accessionNumber: number, updateAntibody: UpdateAntibody, options?: RawAxiosRequestConfig): AxiosPromise<Antibody> {
            return localVarFp.apiRoutersAntibodyUpdateUserAntibody(accessionNumber, updateAntibody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AntibodyApi - object-oriented interface
 */
export class AntibodyApi extends BaseAPI {
    /**
     * Create a Antibody
     * @summary Create Antibody
     * @param {AddAntibody} addAntibody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyCreateAntibody(addAntibody: AddAntibody, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyCreateAntibody(addAntibody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export antibodies as CSV
     * @summary Export Antibodies Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyExportAntibodiesPost(options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyExportAntibodiesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Antibodies
     * @summary Get Antibodies
     * @param {number | null} [page] 
     * @param {number | null} [size] 
     * @param {string | null} [updatedFrom] 
     * @param {string | null} [updatedTo] 
     * @param {string | null} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyGetAntibodies(page?: number | null, size?: number | null, updatedFrom?: string | null, updatedTo?: string | null, status?: string | null, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyGetAntibodies(page, size, updatedFrom, updatedTo, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export all antibodies in csv format
     * @summary Get Antibodies Export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyGetAntibodiesExport(options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyGetAntibodiesExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export all fields of all antibodies to a CSV file - Only for admin users
     * @summary Get Antibodies Export Admin
     * @param {AntibodyStatusEnum | null} [status] 
     * @param {string | null} [lasteditTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyGetAntibodiesExportAdmin(status?: AntibodyStatusEnum | null, lasteditTime?: string | null, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyGetAntibodiesExportAdmin(status, lasteditTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Antibody
     * @summary Get Antibody
     * @param {number} antibodyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyGetAntibody(antibodyId: number, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyGetAntibody(antibodyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get antibody by the accession number
     * @summary Get By Accession
     * @param {number} accessionNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyGetByAccession(accessionNumber: number, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyGetByAccession(accessionNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List user\'s Antibodies
     * @summary Get User Antibodies
     * @param {number | null} [page] 
     * @param {number | null} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyGetUserAntibodies(page?: number | null, size?: number | null, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyGetUserAntibodies(page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a submitted Antibody
     * @summary Update User Antibody
     * @param {number} accessionNumber 
     * @param {UpdateAntibody} updateAntibody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersAntibodyUpdateUserAntibody(accessionNumber: number, updateAntibody: UpdateAntibody, options?: RawAxiosRequestConfig) {
        return AntibodyApiFp(this.configuration).apiRoutersAntibodyUpdateUserAntibody(accessionNumber, updateAntibody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeneralApi - axios parameter creator
 */
export const GeneralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get data information
         * @summary Get Datainfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersGeneralGetDatainfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/datainfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of partners and related images
         * @summary Get Partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersGeneralGetPartners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralApi - functional programming interface
 */
export const GeneralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralApiAxiosParamCreator(configuration)
    return {
        /**
         * Get data information
         * @summary Get Datainfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersGeneralGetDatainfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersGeneralGetDatainfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApi.apiRoutersGeneralGetDatainfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of partners and related images
         * @summary Get Partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersGeneralGetPartners(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerResponseObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersGeneralGetPartners(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApi.apiRoutersGeneralGetPartners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralApi - factory interface
 */
export const GeneralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralApiFp(configuration)
    return {
        /**
         * Get data information
         * @summary Get Datainfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersGeneralGetDatainfo(options?: RawAxiosRequestConfig): AxiosPromise<DataInfo> {
            return localVarFp.apiRoutersGeneralGetDatainfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of partners and related images
         * @summary Get Partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersGeneralGetPartners(options?: RawAxiosRequestConfig): AxiosPromise<Array<PartnerResponseObject>> {
            return localVarFp.apiRoutersGeneralGetPartners(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeneralApi - object-oriented interface
 */
export class GeneralApi extends BaseAPI {
    /**
     * Get data information
     * @summary Get Datainfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersGeneralGetDatainfo(options?: RawAxiosRequestConfig) {
        return GeneralApiFp(this.configuration).apiRoutersGeneralGetDatainfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of partners and related images
     * @summary Get Partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersGeneralGetPartners(options?: RawAxiosRequestConfig) {
        return GeneralApiFp(this.configuration).apiRoutersGeneralGetPartners(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IngestApi - axios parameter creator
 */
export const IngestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ingest antibody\'s csv data into the database
         * @summary Ingest
         * @param {IngestRequest} ingestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersIngestIngest: async (ingestRequest: IngestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestRequest' is not null or undefined
            assertParamExists('apiRoutersIngestIngest', 'ingestRequest', ingestRequest)
            const localVarPath = `/api/ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IngestApi - functional programming interface
 */
export const IngestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IngestApiAxiosParamCreator(configuration)
    return {
        /**
         * Ingest antibody\'s csv data into the database
         * @summary Ingest
         * @param {IngestRequest} ingestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersIngestIngest(ingestRequest: IngestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersIngestIngest(ingestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiRoutersIngestIngest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IngestApi - factory interface
 */
export const IngestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IngestApiFp(configuration)
    return {
        /**
         * Ingest antibody\'s csv data into the database
         * @summary Ingest
         * @param {IngestRequest} ingestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersIngestIngest(ingestRequest: IngestRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.apiRoutersIngestIngest(ingestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IngestApi - object-oriented interface
 */
export class IngestApi extends BaseAPI {
    /**
     * Ingest antibody\'s csv data into the database
     * @summary Ingest
     * @param {IngestRequest} ingestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersIngestIngest(ingestRequest: IngestRequest, options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiRoutersIngestIngest(ingestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search on Antibodies with custom filters
         * @summary Filter Antibodies
         * @param {FilterRequest} filterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchFilterAntibodies: async (filterRequest: FilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterRequest' is not null or undefined
            assertParamExists('apiRoutersSearchFilterAntibodies', 'filterRequest', filterRequest)
            const localVarPath = `/api/search/antibodies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search antibodies (Full Text Search)
         * @summary Fts Antibodies
         * @param {string} q 
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchFtsAntibodies: async (q: string, page?: number | null, size?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiRoutersSearchFtsAntibodies', 'q', q)
            const localVarPath = `/api/fts-antibodies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all applications
         * @summary Get Applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchGetApplications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all species
         * @summary Get Species
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchGetSpecies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/species`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all vendors
         * @summary Get Vendors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchGetVendors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Search on Antibodies with custom filters
         * @summary Filter Antibodies
         * @param {FilterRequest} filterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersSearchFilterAntibodies(filterRequest: FilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAntibodies>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersSearchFilterAntibodies(filterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiRoutersSearchFilterAntibodies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search antibodies (Full Text Search)
         * @summary Fts Antibodies
         * @param {string} q 
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersSearchFtsAntibodies(q: string, page?: number | null, size?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAntibodies>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersSearchFtsAntibodies(q, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiRoutersSearchFtsAntibodies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all applications
         * @summary Get Applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersSearchGetApplications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersSearchGetApplications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiRoutersSearchGetApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all species
         * @summary Get Species
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersSearchGetSpecies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersSearchGetSpecies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiRoutersSearchGetSpecies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all vendors
         * @summary Get Vendors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersSearchGetVendors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VendorSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersSearchGetVendors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiRoutersSearchGetVendors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * Search on Antibodies with custom filters
         * @summary Filter Antibodies
         * @param {FilterRequest} filterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchFilterAntibodies(filterRequest: FilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAntibodies> {
            return localVarFp.apiRoutersSearchFilterAntibodies(filterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search antibodies (Full Text Search)
         * @summary Fts Antibodies
         * @param {string} q 
         * @param {number | null} [page] 
         * @param {number | null} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchFtsAntibodies(q: string, page?: number | null, size?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAntibodies> {
            return localVarFp.apiRoutersSearchFtsAntibodies(q, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all applications
         * @summary Get Applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchGetApplications(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiRoutersSearchGetApplications(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all species
         * @summary Get Species
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchGetSpecies(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiRoutersSearchGetSpecies(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all vendors
         * @summary Get Vendors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersSearchGetVendors(options?: RawAxiosRequestConfig): AxiosPromise<Array<VendorSchema>> {
            return localVarFp.apiRoutersSearchGetVendors(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
    /**
     * Search on Antibodies with custom filters
     * @summary Filter Antibodies
     * @param {FilterRequest} filterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersSearchFilterAntibodies(filterRequest: FilterRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiRoutersSearchFilterAntibodies(filterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search antibodies (Full Text Search)
     * @summary Fts Antibodies
     * @param {string} q 
     * @param {number | null} [page] 
     * @param {number | null} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersSearchFtsAntibodies(q: string, page?: number | null, size?: number | null, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiRoutersSearchFtsAntibodies(q, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all applications
     * @summary Get Applications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersSearchGetApplications(options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiRoutersSearchGetApplications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all species
     * @summary Get Species
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersSearchGetSpecies(options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiRoutersSearchGetSpecies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all vendors
     * @summary Get Vendors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersSearchGetVendors(options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiRoutersSearchGetVendors(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestApi - axios parameter creator
 */
export const TestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks if application is healthy
         * @summary Live
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersTestLive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if application is up
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersTestPing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if application is ready to take requests
         * @summary Ready
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersTestReady: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ready`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestApi - functional programming interface
 */
export const TestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestApiAxiosParamCreator(configuration)
    return {
        /**
         * Checks if application is healthy
         * @summary Live
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersTestLive(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersTestLive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.apiRoutersTestLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if application is up
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersTestPing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersTestPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.apiRoutersTestPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if application is ready to take requests
         * @summary Ready
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRoutersTestReady(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoutersTestReady(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestApi.apiRoutersTestReady']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestApi - factory interface
 */
export const TestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestApiFp(configuration)
    return {
        /**
         * Checks if application is healthy
         * @summary Live
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersTestLive(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiRoutersTestLive(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if application is up
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersTestPing(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiRoutersTestPing(options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if application is ready to take requests
         * @summary Ready
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRoutersTestReady(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiRoutersTestReady(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestApi - object-oriented interface
 */
export class TestApi extends BaseAPI {
    /**
     * Checks if application is healthy
     * @summary Live
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersTestLive(options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).apiRoutersTestLive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if application is up
     * @summary Ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersTestPing(options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).apiRoutersTestPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if application is ready to take requests
     * @summary Ready
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRoutersTestReady(options?: RawAxiosRequestConfig) {
        return TestApiFp(this.configuration).apiRoutersTestReady(options).then((request) => request(this.axios, this.basePath));
    }
}



